export default "__VITE_ASSET__68c0fd3f__"